export default "__VITE_ASSET__iBqM93iM__"